<template>
  <div class="container-fluid mt-4">
    <div class="row mb-5">
      <div class="col-lg-3">
        <side-nav :sections="userSideNav" />
      </div>
      <div class="col-lg-9 mt-lg-0 mt-4">
        <!-- 로딩 상태 -->
        <div v-if="loading" class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>

        <!-- 데이터 로드 완료 -->
        <template v-else-if="userData">
          <!-- 기본 정보 카드 -->
          <basic-info-card
            :basic-data="userData"
            :is-user="true"
            @update-field="handleUpdateField"
            @save-changes="handleSaveChanges"
          />

          <!-- 비밀번호 변경 카드 -->
          <password-change-card @update-password="handlePasswordChange" />
          
        </template>

        <!-- 데이터 없음 -->
        <div v-else class="alert alert-warning">
          사용자 정보를 찾을 수 없습니다.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BasicInfoCard from "@/views/users/components/BasicInfoCard.vue";
import PasswordChangeCard from "@/views/users/components/PasswordChangeCard.vue";
import SideNav from "@/views/users/components/SideNav.vue";

export default {
  name: "UserDetail",
  components: {
    BasicInfoCard,
    PasswordChangeCard,
    SideNav,
  },
  data() {
    return {
      userId: null,
      userData: null,
      loading: false,
      updateFields: {},
      userSideNav: [
        { id: 'basic-info', icon: 'receipt_long', label: '기본 정보' },
        { id: 'password', icon: 'lock', label: '비밀번호 변경' },
      ],
    };
  },
  created() {
    this.userId = this.$store.state.auth.user_info.idx;
    this.loadUserData();
  },
  methods: {
    async loadUserData() {
      this.loading = true;
      try {
        const res = await this.$axios({
          method: "get",
          url: `/roles/editors/${this.userId}`,
          loadingBar: true,
        });
        
        if (res.status === 200) {
          this.userData = res.data;
        }
      } catch (error) {
        console.error("사용자 정보 로드 실패:", error);
        if (error.response?.status === 404) {
          alert("사용자를 찾을 수 없습니다.");
        } else {
          alert("사용자 정보를 불러오는데 실패했습니다.");
        }
      } finally {
        this.loading = false;
      }
    },

    handleUpdateField({ field, value }) {
      //console.log('handleUpdateField 호출:', field, value);
      this.updateFields = {
        ...this.updateFields,
        [field]: value
      };
      //console.log('updateFields 업데이트:', this.updateFields);
    },

    async handleSaveChanges() {
      //console.log('저장 시도, updateFields:', this.updateFields);
      if (Object.keys(this.updateFields).length === 0) {
        alert("변경된 내용이 없습니다.");
        return;
      }

      // 이번 저장분만 보낸다 — 실패한 시도의 값(예: 중복 이메일)이 다음 저장에 다시 실리지 않게 바로 비운다
      const data = this.updateFields;
      this.updateFields = {};

      try {
        //console.log('요청 URL:', `/roles/editors/${this.userId}`);
        //console.log('요청 데이터:', JSON.stringify(data, null, 2));

        await this.$axios({
          method: "put",
          url: `/roles/editors/${this.userId}`,
          data
        });

        //console.log('응답:', res);
        alert("사용자 정보가 성공적으로 수정되었습니다.");
        await this.loadUserData();
      } catch (error) {
        //console.error("관리자 정보 수정 실패 - 전체 에러:", error);
        //console.error("응답 데이터:", error.response?.data);
        //console.error("응답 상태:", error.response?.status);
        //console.error("요청 설정:", error.config);

        // 400(입력 길이 초과·이미 쓰이는 이메일)·403(본인 아님) 의 detail 은 그대로 띄울 수 있는 문장이다
        const detail = error.response?.data?.detail;
        if ([400, 403].includes(error.response?.status) && typeof detail === 'string') {
          alert(detail);
          return;
        }

        let errorMessage = "사용자 정보 수정에 실패했습니다.";

        if (error.response?.status === 404) {
          errorMessage = "사용자를 찾을 수 없습니다.";
        } else if (error.response?.data) {
          // 백엔드에서 반환하는 다양한 에러 형식 처리
          if (typeof error.response.data === 'string') {
            errorMessage = error.response.data;
          } else if (typeof error.response.data.detail === 'string') {
            errorMessage = error.response.data.detail;
          } else if (error.response.data.message) {
            errorMessage = error.response.data.message;
          }
        }

        alert(`${errorMessage}\n\n상세 정보는 콘솔을 확인하세요.`);
      }
    },

    async handlePasswordChange({ current, new: newPassword }) {
      try {
        await this.$axios({
          method: "post",
          url: "/auth/editor/change-password",
          data: {
            current_password: current,
            new_password: newPassword
          },
          loadingBar: true
        });
        alert("비밀번호가 변경되었습니다.");
      } catch (error) {
        console.error("비밀번호 변경 실패:", error);
        const msg = error?.response?.data?.detail || error?.response?.data?.message || "비밀번호 변경에 실패했습니다.";
        alert(msg);
      }
    },
  },
};
</script>
